import React from 'react';
import { useLocation } from 'react-router-dom';
import { DashboardCreateSkeleton } from './DashboardCreateSkeleton';
import { DashboardWorkspaceSkeleton } from './DashboardWorkspaceSkeleton';
import { dashboardSkeletonKind } from './dashboardSkeletonKind';

/**
 * The section's loading shape for whichever of its four screens the URL names.
 *
 * Read off the location and not passed by each route because there is **one**
 * Suspense boundary for the four, inside `DashboardsGate` and below the draft
 * provider (see the comment there for why it cannot be one per route, or above
 * the provider). The same component is what `RouteSkeleton` draws inside the app
 * chrome on a cold load, so the two loading phases look the same.
 *
 * A path the section does not know falls back to the read-only view, the
 * screen most links point at.
 */
export const DashboardRouteSkeleton: React.FC = () => {
  const { pathname } = useLocation();
  const kind = dashboardSkeletonKind(pathname) ?? 'view';

  return kind === 'create' ? (
    <DashboardCreateSkeleton />
  ) : (
    <DashboardWorkspaceSkeleton mode={kind} />
  );
};
